import { CadastreIdentity } from "../../Types/EstateTypes";

export const matrikkelString = (ident: CadastreIdentity) => 
    `${ident.kommunenr}/${ident.gardsnr}/${ident.bruksnr}/${ident.seksjonsnrSpecified ? ident.seksjonsnr : 0}/${ident.festenrSpecified ? ident.festenr : 0}`;